import { z } from "zod"

import { ethereumAddress } from "../base"

const clsetItem = z.object({
  name: z.string(),
  info: z.object({
    docs: z.string(),
    analytics: z.string(),
    providerApp: z.string(),
  }),
  config: z.object({
    token: z.object({
      address: ethereumAddress,
      symbol: z.string(),
      decimals: z.number(),
    }),
    farm: ethereumAddress,
    vault: ethereumAddress,
    voter: ethereumAddress,
    guard: ethereumAddress.optional(),
    vdep: ethereumAddress.optional(),
    mintTokens: z
      .array(
        z.object({
          symbol: z.string(),
          address: ethereumAddress,
          decimals: z.number(),
          minimumAmount: z.string(),
        }),
      )
      .optional(),
    flipLensTokens: z.boolean(),
    slipBps: z.number().optional(),
    pool: ethereumAddress.optional(),
    buck1: z.number().optional(),
  }),
  description: z.string(),
  token0: z.object({
    symbol: z.string(),
    address: ethereumAddress,
    decimals: z.number(),
  }),
  token1: z.object({
    symbol: z.string(),
    address: ethereumAddress,
    decimals: z.number(),
  }),
  tokenEarn: z.object({
    symbol: z.string(),
    address: ethereumAddress,
    decimals: z.number(),
  }),
  alm: z.string(),
  dex: z.string(),
  tags: z.array(z.string()),
  isProductionReady: z.boolean(),
  isSingleSided: z.boolean(),
  integration: z.object({
    fees: ethereumAddress.nullable(),
    clPool: ethereumAddress,
    equalizerPair: z.object({
      address: ethereumAddress,
      displayName: z.string(),
      displayType: z.string(),
      extendedType: z.string(),
      tags: z.array(z.string()),
      apr: z.number(),
      tvlUsd: z.number(),
    }),
    gauge: z
      .object({
        address: ethereumAddress,
        bribeAddress: ethereumAddress,
        apr: z.number(),
        rewardRate: z.number(),
        totalSupply: z.number(),
        votes: z.number(),
        votesPercent: z.number(),
        incentives: z.record(
          ethereumAddress,
          z.object({
            symbol: z.string(),
            priceUsd: z.number(),
            rewardAmount: z.number(),
            rewardAmountUsd: z.number(),
          }),
        ),
      })
      .nullable(),
    bribes: ethereumAddress.nullable(),
    isStable: z.boolean(),
  }),
})

export const clsetResponseSchema = z.record(z.string(), clsetItem)

export type ClsetResponse = z.infer<typeof clsetResponseSchema>
export type ClsetResponseItem = ClsetResponse[number]
